// Centralized error logging. Replaces silent empty catch blocks so failures are
// at least visible in development; in production it stays quiet (no console
// noise for users) but is the single place to later wire up remote reporting.

export function logError(error, context) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(context ? `[${context}]` : '[error]', error)
  }
}

export default logError
